<!-- 嵌入模式展示   公共大图加图片信息组件    imageLoadOverEvent -- 子组件触发此函数，子组件传参数  -->
<template>
  <div id="imgShowConvas">
      <oneImageInfoShowCom ref="imgShowBox"
        @imageLoadOverEvent="handleImageLoadOverFun"
      ></oneImageInfoShowCom>
      <div id="imgBoxList" style="margin-top: 10px; display: none;" > <!-- 推荐相关  暂时隐藏 ---------------------------->
        <div
          style="width:100%; height:40px; text-align: left;font-size:16px;color:rgb(255, 255, 255);"
        >
          相关推荐 <span style="font-size:20px;">{{ titleG }}</span>
        </div>
        <div v-if="isNoResult" id="resInfo">没有找到图像...</div>
        <div v-else id="imgBoxList_2">
          <div class="rowPan" v-for="(iArray, index) in rowsArray" :key="index">
            <span
              class="keyline"
              v-if="
                currentPage === totalPages && index === rowsArray.length - 1
              "
            >
              <rowColumn
                :rowRole="1"
                :swImgs="iArray"
                :isLastArray="true"
              ></rowColumn>
            </span>
            <span class="keyline" v-else>
              <rowColumn
                :rowRole="1"
                :swImgs="iArray"
                :isLastArray="false"
              ></rowColumn>
            </span>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
/**
 * 组件说明:
 * 当前组件大部分都在管理对应标签的推荐
 * 其他内容都在子组件里面
 */
import rowColumn from './boxRely/row'
import oneImageInfoShowCom from './imgInfoRely/oneImageInfoShow'
// 调用外部js 文件里的函数 操作DOM {unId: 4, relY: 0, relX: 0, info: "edede"}
import { zoomAndDrag, suitToImgPan, zoomImage } from '@/util/tool.js'
export default {
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted () {
    this.toTop()
    // this.handleScorll()
  },
  data () {
    return {
      vueId: 'imageShowCanvas.vue',
      imgId: '',
      imgName: '',
      currentPage: 1,
      totalitems: 0,
      totalPages: 0,
      pageSize: 100,
      swImgs: [], // 检索结果集
      iPos: 0, // 当前页面翻页浏览图像 图像数组游标
      swImgsOnlyShowName: [], // 用来保存只显示图名的结果集
      isNoResult: false,
      rowsArray: [], // 木桶显示保存数组
      lastRow: [], // 不止一页的情况下 非最后一页最后一行显示可能会缺部分，这时候不显示他等翻页的时候再把它加进去
      rebackCount: 0, // 木桶显示的话最后一行可能不能占满行 所以这页就不显示了，下次请求其实号就往回缩几张 0：不回缩  N:缩N张图
      isLoading: false,
      newReSearch: true, // 是否是重新点击分类或者关键词检索， 是的话就把 this.columnArray 清空
      imgH: 0, // 原始图高
      imgW: 0, // 原始图宽
      imgRatio: 0.8, // 现在缩放后和原始大小的比例
      titleG: '', // 图像组名
      reFreshGroupImg: false // 点组内图片 是否刷新组内图
    }
  },
  methods: {
    resetTopAndLeft (imgLeft, imgTop) {
      // 因为导入的图像控制js 函数内有加载标签的功能 所以在这里声明两个函数 但是先不操作
      // 标签函数1
    },
    refreshNotes () {
      // 标签函数2
    },
    toTop () {
      this.$nextTick(() => {
        if (typeof this.$refs.groupScrollbar !== 'undefined') {
          this.$refs.groupScrollbar.wrap.scrollTop = 0
        }
      })
    },
    handleScorll () {
      // 监听滚动条状态
      const _self = this
      if (typeof this.$refs.groupScrollbar === 'undefined') {
        // 修复未定义的bug
        return
      }
      const scrollbarEl = this.$refs.groupScrollbar.wrap
      scrollbarEl.onscroll = function () {
        const viewHeight = scrollbarEl.firstChild.clientHeight // 内容区高度
        const viewportHeight = scrollbarEl.clientHeight // 视窗高度
        const ppb = scrollbarEl.scrollTop
        const marginBottom = viewHeight - viewportHeight - ppb
        // let harfHeight = viewportHeight / 2
        if (marginBottom < viewportHeight) {
          if (!_self.isLoading) {
            // console.log('...读取下页数据')
            if (_self.currentPage < _self.totalPages) {
              _self.newReSearch = false // 还有数据 则设为false 让请求的新数据补充到显示数组中
              _self.isLoading = true // 把当前状态设为正在加载中
              _self.currentPage++
              // _self.searchImagesWithKeyWords(_self.searchKey, _self.typeClass, _self.currentPage, _self.pageSize)
              _self.searchImages(_self.currentPage, _self.pageSize)
            } else {
              _self.newReSearch = true // 没有数据了则设为true  让新请求（重新点分类或检索词）的新数据覆盖至新的数据
            }
          }
        }
      }
    },
    reiInitArray (parray) {
      if (this.newReSearch) {
        // 重新检索而来  而不是滚动条Loadmore
        this.rowsArray = []
        this.lastRow = []
        this.swImgsOnlyShowName = parray
      } else {
        for (const i in parray) {
          this.swImgsOnlyShowName.push(parray[i])
        }
      }

      const len = parray.length // 当前结果集
      let oneRowArray = [] // 当前行数组
      const aspectRatio = 14 // 宽高比 默认6
      const iHeight = 100 // 默认图像高度

      let i = 0 // 数组游标
      let totalRatio = 0.0 // 某行内的图片总的宽高比
      let ratio = 0.0 // 当前某页的宽高比

      while (i < len) {
        ratio = parseFloat(parray[i].iwith) / parseFloat(iHeight) // 当前图片宽高比
        totalRatio = totalRatio + ratio
        if (totalRatio < aspectRatio) {
          oneRowArray.push(parray[i])
        } else {
          this.rowsArray.push(oneRowArray) // 把旧有的放到一行组里

          totalRatio = ratio // 另起一组
          oneRowArray = []
          oneRowArray.push(parray[i])
        }
        i++
      }
      if (this.currentPage < this.totalPages) {
        this.rebackCount = oneRowArray.length
      } else {
        this.rebackCount = 0
      }
      if (this.currentPage === this.totalPages) {
        this.rowsArray.push(oneRowArray) // 把所有有的放到一行组里
      }
      if (parray != null && parray.length > 0) {
        this.isLoading = false // 重置状态 可继续加载数据
      }
      // console.log(this.rowsArray.map((row)=>row.length).reduce((r,r2)=>r + r2), len - this.rebackCount) // 校验展示的数据和获取的数据总量是否一致
    },
    searchImages (pageNo, pageSize) {
      this.currentPage = pageNo // 设置当前页码
      // this.$emit('beginSearch', '参数1') // 用来触发父组件定义的@beginSearch

      const api = '/md/front/paid/image/groupSearch'
      const params = {
        titleG: this.titleG,
        imgId: this.imgId,
        pageSize: pageSize,
        pageNo: pageNo,
        rebackCount: this.rebackCount
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status !== 200) {
          return
        }
        res = res.data
        const resMap = res

        if (resMap.flag) {
          if (resMap.data != null) {
            this.isNoResult = false
            this.swImgs = resMap.data

            const rsCount = resMap.total
            this.totalitems = rsCount

            const count = rsCount % this.pageSize
            if (count === 0) {
              this.totalPages = rsCount / this.pageSize
            } else {
              this.totalPages = Math.floor(rsCount / this.pageSize) + 1
            }
            // 显示当前检索的结果数
            // this.currentPage = resMap.page
            this.reiInitArray(resMap.data)
          } else {
            this.isNoResult = false // 无论请求的结果是否有值, 都必须给用户显示提示内容
            this.swImgs = []
            this.totalitems = resMap.total
          }
        } else {
          this.$alert(resMap.info, '提示')
        }
      })
      // alert('开始检索了：' + value)
    },
    setImgSize (width, height) {
    },
    setImgSize_ (width, height) {
      // eslint-disable-next-line no-debugger
      debugger
      // 大图加载完调整大图的尺寸， 同时开始读取 同类型推荐图片列表
      // this.loadNotes(this.imgId) // 加载标签
      // this.showLoad = false
      setTimeout(() => {
        try {
          const oImg = document.getElementById('bimg')
          this.imgH = height
          this.imgW = width
          // console.log('内嵌图片的高度和宽度: '+this.imgH + '--' + this.imgW, this.imgH/this.imgW)
          zoomAndDrag('bimg', this)
          oImg.className = 'onehand'
          const oParent = oImg.parentNode
          // alert(oParent.clientWidth + '---' + oParent.clientHeight)
          suitToImgPan(
            oParent.clientHeight,
            oParent.clientWidth,
            this.imgH,
            this.imgW,
            'bimg',
            2,
            2
          )
          // 开始加载组图
          if (this.reFreshGroupImg) {
            this.rowsArray = []
            // this.searchImages(1, this.pageSize) // 开始加载同类型推荐图片列表
          }
          if (this.imgH / this.imgW < 0.1) {
            // 只有宽高比达到一定程度的时候才自动放大图片
            // console.log('执行缩放函数')
            zoomImage(false)
            zoomImage(false)
            zoomImage(false)
            zoomImage(false)
            zoomImage(false)
            zoomImage(false)
          }
        } catch (error) {
          setTimeout(() => {
            const height = this.imgH
            const width = this.imgW
            this.setImgSize(width, height)
          }, 100)
        }
      }, 100)
    },
    handleImageLoadOverFun (
      imageTypeName,
      imageID,
      reFreshGroupImg,
      width,
      height
    ) {
      // eslint-disable-next-line no-debugger
      debugger
      this.titleG = imageTypeName
      this.imgId = imageID
      this.reFreshGroupImg = reFreshGroupImg
      this.setImgSize(width, height)
    }
  },
  computed: {
    closeMaskState () {
      return this.$store.state.events.closeMaskState
    }
  },
  watch: {
    closeMaskState () {
      // 当全屏看图结束后放大缩小的句柄还保留在全屏组件里面, 这时就需要重新获取句柄并应用到内嵌的看图页面里面
      const height = this.imgH
      const width = this.imgW
      this.setImgSize(width, height)
    }
  },
  components: {
    rowColumn: rowColumn,
    oneImageInfoShowCom: oneImageInfoShowCom
  }
}
</script>
<style scoped>
#groupBar {
  height: 100%;
}
.rowPan {
  width: 98%;
  margin-bottom: 20px;
}
</style>
